import { map } from "@newdash/newdash/map";
import { Token, TokenType } from "./lexer";

export type SourceArray = number[] | Uint16Array;

export function stringify(
  value: SourceArray,
  index: number,
  next: number,
): string {
  return map(value.slice(index, next), (ch: number) =>
    String.fromCodePoint(ch),
  ).join("");
}

export function is(value: number, compare: string) {
  for (let i = 0; i < compare.length; i++) {
    if (value === compare.codePointAt(i)) {
      return true;
    }
  }

  return false;
}

export function equals(value: SourceArray, index: number, compare: string) {
  let i = 0;
  while (value[index + i] === compare.codePointAt(i) && i < compare.length) {
    i++;
  }
  return i === compare.length ? i : 0;
}

export function required(
  value: SourceArray,
  index: number,
  comparer: (value: number) => boolean,
  min?: number,
  max?: number,
) {
  let i = 0;

  max = max || value.length - index;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  while (i < max && comparer(value[index + i]!)) {
    i++;
  }

  return i >= (min || 0) && i <= max ? index + i : 0;
}

export function isType<T extends TokenType>(
  node: any,
  type: T,
): node is Token<T> {
  return node instanceof Token && node?.type == type;
}

export function assertType<T extends TokenType>(
  node: any,
  tokenType: T,
): asserts node is Token<T> {
  if (!isType(node, tokenType)) {
    const received = node instanceof Token ? node.type : JSON.stringify(node);
    throw new Error(
      `Expected token of type ${tokenType}, received: ${received}`,
    );
  }
}

export default { stringify, is, equals, required };
